export default function slugify(input: string): string {
  return input
    .trim()
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]/g, '')
}
